import { CHECKOUT_CMS_COMPONENT_MAPPING } from '@checkout/shell';
import {
  CmsComponentMapping,
  CORE_CMS_COMPONENT_MAPPING,
} from '@domgen/dgx-fe-cms';
import { ERROR_CMS_COMPONENT_MAPPING } from '@error/shell';
import { SUPPORT_CMS_COMPONENT_MAPPING } from '@support/shell';
import { APPLIANCE_REGISTRATION_CMS_COMPONENT_US_MAPPING } from '@us-registration/shell';

export const APP_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  ...APPLIANCE_REGISTRATION_CMS_COMPONENT_US_MAPPING,
  ...CHECKOUT_CMS_COMPONENT_MAPPING,
  ...CORE_CMS_COMPONENT_MAPPING,
  ...ERROR_CMS_COMPONENT_MAPPING,
  ...SUPPORT_CMS_COMPONENT_MAPPING,
};
